import { fromZonedTime } from 'date-fns-tz';

export const getOffsetLabel = (date: string): string => {
  const parsedDate = fromZonedTime(date, 'UTC');
  const offset = -parsedDate.getTimezoneOffset() / 60;

  return offset >= 0 ? `UTC+${offset}` : `UTC${offset}`;
};
